import { mapState, mapGetters } from 'vuex'
import { openLineLink } from '@/utils/openLineLink'
export default {
  computed: {
    ...mapState(['guestPurchase', 'url']),
    ...mapGetters(['isGuestAgent']),
    isGuestPurchase () {
      return Boolean(this.guestPurchase.createGuestAccountData) && !this.$auth.loggedIn
    }
  },
  methods: {
    async checkIsAvaliablePhoneNumber (Phone) { // 訪客驗證手機是否已是會員 or 已刪除的會員
      if (!this.$auth.loggedIn) {
        try {
          const isKingnetMember = await this.CheckIsKingnetMemberByPhone(Phone)
          if (isKingnetMember) {
            const isDeletedMember = await this.CheckIsDeletedKingnetMemberByPhone(Phone)
            if (isDeletedMember) {
              this.$alert({
                title: '系統提示',
                message: '此手機號碼已有刪除會員紀錄，若仍需訂購請聯繫客服人員',
                persistent: true,
                btn: [
                  {
                    btnText: '換個號碼',
                    btnClick: () => {
                      this.$gaLogEvent('會員提示', '會員已刪除_換個號碼')
                      this.$alert.close()
                    }
                  },
                  {
                    btnText: '立即聯繫',
                    btnColor: 'primary',
                    btnClick: () => {
                      this.$gaLogEvent('會員提示', '會員已刪除_立即聯繫')
                      openLineLink(this.$store.state.isApp)
                      this.$alert.close()
                    }
                  }
                ]
              })
              return false
            }
            if (this.isGuestAgent) {
              this.$alert({
                title: '系統提示',
                message: '當前手機號碼已存在會員資料，請確認資訊後重新嘗試或關閉頁面使用會員代訂功能',
                persistent: true,
                btn: [
                  {
                    btnText: '我知道了',
                    btnColor: 'primary',
                    btnClick: () => {
                      this.$alert.close()
                    }
                  }
                ]
              })
              return false
            }
            this.$gaLogEvent('會員提示', '會員已存在')
            this.$alert({
              title: '會員提示',
              message: '當前手機號碼已存在會員資料，請登入後繼續進行訂購',
              persistent: true,
              btn: [
                {
                  btnText: '取消',
                  btnClick: () => {
                    this.$alert.close()
                  }
                },
                {
                  btnText: '確定',
                  btnColor: 'primary',
                  btnClick: () => {
                    if (typeof this.memberLogin === 'function') {
                      this.memberLogin()
                    } else {
                      this.$emit('memberLogin')
                    }
                    this.$alert.close()
                  }
                }
              ]
            })
            return false
          } else {
            return true
          }
        } catch (err) {
          console.log(err)
          return false
        }
      } else return false
    },
    async CheckIsKingnetMemberByPhone (Phone) {
      try {
        const { data } = await this.$axios.get('api/Account/CheckIsKingnetMemberByPhone', { params: { Phone } })
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    async CheckIsDeletedKingnetMemberByPhone (Phone) {
      try {
        const { data } = await this.$axios.get('api/Account/CheckIsDeletedKingnetMemberByPhone', { params: { Phone } })
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    }
  }
}
